"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightenAndDarken = exports.isDark = exports.isLight = void 0;
var Color = require("color");
/**
 * @param {string}  color - A string param (the color to check if is light).
 *
 * @returns {boolean}
 */
var isLight = function (color) {
    var value = Color(color);
    return value.isLight();
};
exports.isLight = isLight;
/**
 * @param {string}  color - A string param (the color to check if is dark).
 *
 * @returns {boolean}
 */
var isDark = function (color) {
    var value = Color(color);
    return value.isDark();
};
exports.isDark = isDark;
/**
 * @param {string}  color - A string param to lighten or darken.
 * @param {darkPercentage}  number - the percentage to define how mush to change the color if is dark
 * @param {lightPercentage}  number - the percentage to define how mush to change the color if is light
 *
 * @returns {string}
 */
var lightenAndDarken = function (color, darkPercentage, lightPercentage) {
    var value = Color(color);
    // check if color is Light or Dark
    if ((0, exports.isLight)(color)) {
        return value.lightness(lightPercentage).hex();
    }
    return value.lightness(darkPercentage).hex();
};
exports.lightenAndDarken = lightenAndDarken;
